import React from "react";

/**
 * AlarmCard Component - Displays alarm counts for divisions and stations
 * Used in Unified Alarm Dashboard for both Division and Station cards
 *
 * @param {string} label - Display name (division code or station name)
 * @param {string} card_id - Unique identifier for the card
 * @param {string} Total_cnt - Total asset count
 * @param {string} pf_cnt - Predictive Failure count
 * @param {string} fl_cnt - Failure count
 * @param {string} mf_cnt - Maintenance Failure count
 * @param {string} mo_cnt - Maintenance Overdue count
 * @param {object} raw_packet - Raw data packet for click handling
 * @param {string} selectedCardId - Currently selected card ID
 * @param {function} handleClick - Click handler for card selection
 * @param {function} handleAlarmCardCounClick - Click handler for individual alarm counts
 */
const AlarmCard = ({
  label,
  card_id,
  Total_cnt,
  pf_cnt,
  fl_cnt,
  mf_cnt,
  mo_cnt,
  raw_packet,
  selectedCardId,
  handleClick,
  handleAlarmCardCounClick,
}) => {
  const isSelected = card_id === selectedCardId;

  return (
    <div
      onClick={() => {
        handleClick(raw_packet);
      }}
      className={`unified-alarm-card ${isSelected ? "unified-alarm-card__selected" : ""}`}
    >
      <div className="lable-total-cnt-box">
        <div className="cnt-card-label">{label}</div>
        <div className="total-cnts">{Total_cnt}</div>
      </div>
      <div className="alarm-total-cnt-box">
        <div
          className="pf-alarm-background"
          onClick={(event) => {
            event.stopPropagation();
            handleAlarmCardCounClick("alarm", card_id, "pf");
          }}
        >
          {pf_cnt}
        </div>
        <div
          className="fl-alarm-background"
          onClick={(event) => {
            event.stopPropagation();
            handleAlarmCardCounClick("alarm", card_id, "fl");
          }}
        >
          {fl_cnt}
        </div>
        <div
          className="mo-alarm-background"
          onClick={(event) => {
            event.stopPropagation();
            handleAlarmCardCounClick("mis", card_id, "mo");
          }}
        >
          {mo_cnt}
        </div>
        <div
          className="mf-alarm-background"
          onClick={(event) => {
            event.stopPropagation();
            handleAlarmCardCounClick("mis", card_id, "mf");
          }}
        >
          {mf_cnt}
        </div>
      </div>
    </div>
  );
};

export default AlarmCard;
